import { createFilterOptions } from '@mui/material/Autocomplete';

export const handleClose = (event, reason, setState) => {
  if (reason === 'clickaway') {
    return;
  }
  // setState(false);
};

export const defineTicketNumber = (
  ticketType,
  ticketId,
  ticketNumberLenght,
  preCursor
) => {
  // let preCursor = ticketType === 'repair' ? 'R' : 'I';

  let definedPreNumber = ticketId + '';
  while (definedPreNumber.length < ticketNumberLenght)
    definedPreNumber = '0' + definedPreNumber;
  return preCursor + definedPreNumber;
};
export const defineTicketNumberV2 = (row, ticketNumberLenght) => {
  let preCursor = row.row.ticket_type === 'repair' ? 'R' : 'I';

  let definedPreNumber = row.row.id + '';
  while (definedPreNumber.length < ticketNumberLenght)
    definedPreNumber = '0' + definedPreNumber;
  return preCursor + definedPreNumber;
};

export const defineTicketNumberV3 = (
  ticket_type,
  ticket_id,
  ticketNumberLenght
) => {
  let preCursor = ticket_type === 'repair' ? 'R' : 'I';

  let definedPreNumber = ticket_id + '';
  while (definedPreNumber.length < ticketNumberLenght)
    definedPreNumber = '0' + definedPreNumber;
  return preCursor + definedPreNumber;
};

// EXPIRY DATE CALCULATOR WITH DATE FORMAT dd/mm/yyyy
export const expiryDate = (date, warrantee) => {
  const warranteePeriod = parseFloat(warrantee) * 365;
  const getWarranteeDate = new Date(date);
  getWarranteeDate.setDate(getWarranteeDate.getDate() + warranteePeriod);
  // console.log(getWarranteeDate);
  return getWarranteeDate
    .toLocaleString('en-GB', { timeZone: 'UTC' })
    .slice(0, 10);
};

// DATE FORMAT CONVERTER dd/mm/yyyy
export const converDate = (date) => {
  const getWarranteeDate = new Date(date);
  getWarranteeDate.setDate(getWarranteeDate.getDate());
  return getWarranteeDate
    .toLocaleString('en-GB', { timeZone: 'UTC' })
    .slice(0, 10);
};

// DATE FORMAT CONVERTER
export const convertDate = (date, sliceStart, sliceEnd) => {
  const getNewDate = new Date(date);
  getNewDate.setDate(getNewDate.getDate());
  return getNewDate.toLocaleString('en-GB').slice(sliceStart, sliceEnd);
};

// DATE FORMAT CONVERTER dd/mm/yyyy
export const converDateWithTime = (date) => {
  const getWarranteeDate = new Date(date);
  getWarranteeDate.setDate(getWarranteeDate.getDate());
  return getWarranteeDate.toLocaleString('en-GB').slice(0, 17);
};

// DATE FORMAT CONVERTER dd/mm/yyyy
export const convertToTime = (date) => {
  const getWarranteeDate = new Date(date);
  getWarranteeDate.setDate(getWarranteeDate.getDate());
  return getWarranteeDate.toLocaleString('en-GB').slice(11, 17);
};

// OPTIONS LIST MAPPER
export const optionsList = (data) => {
  const options = [...data];
  const optionItems = options.map((option) => {
    return (
      <option key={option.id} value={option.id}>
        {option.name}
      </option>
    );
  });
  return optionItems;
};

// DEFINE HEADER TITLES
export const titleHandler = (path) => {
  let pathname = path;
  switch (pathname) {
    case '/ticket':
      return 'Ticket Control';
    case '/ticket/repair_ticket_edit':
      return 'Ticket Control - Repair Ticket';
    case '/ticket/repair_ticket_auth':
      return 'Repair Ticket Control - Auth';
    case '/ticket/install_ticket_edit':
      return 'Ticket Control - Install Ticket';
    case '/ticket/install_ticket_auth':
      return 'Install Ticket Control - Auth';
    case '/archive':
      return 'Archived Tickets';
    case '/tech/tickets':
      return 'Tech - Tickets';
    case '/tech/timeandattendance':
      return 'Tech - Time and Attendance';
    case '/tech/tech_ticket_view':
      return 'Tech Control - View';
    case '/warrantee':
      return 'Warrantee Control';
    case '/customer':
      return 'Customer Control';
    case '/customer/customer_edit':
      return 'Customer Control - Edit';
    case '/customer/customer_new':
      return 'Customer Control - Add';
    case '/serial':
      return 'Serial Control';
    case '/serial/serial_history':
      return 'Serial Control - History';
    case '/jobcard':
      return 'Job Card';
    case '/installreport':
      return 'Install Report';
    case '/admin/constants':
      return 'Admin - Constants';
    case '/admin/time&attendance':
      return 'Admin - Time & Attendance';
    case '/admin/consumables':
      return 'Admin - Stock';
    case '/admin/users':
      return 'Admin - Users';
    case '/reports/install_analysis':
      return 'Report - Install Analysis';
    case '/reports/payroll':
      return 'Report - Payroll';
    case '/reports/spares_usage':
      return 'Report - Spares Usage';
    case '/reports/bulk_data':
      return 'Report - Bulk Data';
    case '/reports/ticketing':
      return 'Report - Ticketing';
    default:
      return 'Multilayer Trading Ticket Control System';
  }
};

// FIND GUID FOR AUTOCOMPLETE SELECTOR
export const findGuid = (guid, objectSet) => {
  let found = null;
  for (let i = 0; i < objectSet.length; i++) {
    if (objectSet[i].id === guid) {
      found = objectSet[i];
      break;
    }
  }
  return found;
};
export const findGuidByName = (name, objectSet) => {
  let found = null;
  for (let i = 0; i < objectSet.length; i++) {
    if (objectSet[i].name === name) {
      found = objectSet[i];
      break;
    }
  }
  return found;
};

//AUTOCOMPLETE FILTER
export const filterMethod = createFilterOptions({
  matchFrom: 'any',
  stringify: (option) => option.name,
});
export const filterMethodAll = createFilterOptions({
  limit: 30,
  matchFrom: 'any',
  stringify: (option) => option.name,
});

export const filterStockMethod = createFilterOptions({
  matchFrom: 'start',
  stringify: (option) => option.code,
});
export const filterDescriptionMethod = createFilterOptions({
  matchFrom: 'start',
  stringify: (option) => option.description,
});

export const returnListObject = (objName, guVal, guList) => {
  let ObjectName = objName;
  let GuiValue = guVal;
  let GuiListName = guList;

  ObjectName = findGuid(GuiValue, GuiListName);
  return ObjectName;
};

export const snackMessage = (type, extension, stateSetter) => {
  switch (type) {
    case 'email':
      stateSetter(`Check ${extension} Email Format!`);
      break;

    case 'required':
      stateSetter(`Complete ${extension} Before Saving!`);
      break;

    default:
      stateSetter(`Complete All Required Fields Before Saving!`);
      break;
  }
};

export const checkEmail = (email) => {
  const mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  if (email.match(mailFormat)) {
    return false;
  } else {
    return true;
  }
};

export const validateEmptyMail = (inputState) => {
  if (inputState.trim().length !== 0 && checkEmail(inputState) === true) {
    return true;
  } else {
    return false;
  }
};

export const validateRequired = (inputState) => {
  if (inputState === '' || inputState === undefined || inputState === null) {
    return true;
  } else {
    return false;
  }
};

export const multiplyArrayObjects = (val1, val2) => {
  let sumItems = Number.parseFloat(val1) * Number.parseFloat(val2);

  return sumItems.toFixed(2);
};

export const sumArrayObjects = (arr, item) => {
  let sumItems;
  sumItems = arr.map((list) => Number.parseFloat(list[item]));
  return sumItems.reduce(add, 0.0).toFixed(2);
};

function add(accumulator, a) {
  return accumulator + a;
}

export const greyOutEmptyTextField = (text) => {
  if (text && text.length > 0) {
    return 'none';
  }
  return '#00334433';
};

export const changeFirstToUpper = (word) => {
  if (typeof word === 'string') {
    let firstLetter = word.charAt(0).toUpperCase();

    return firstLetter + word.substring(1);
  }
  return null;
};
